module.exports = __webpack_public_path__ + "img/distribuidoresEnergia.fc9267d0.svg";